import { Tooltip, CircularProgress } from '@mui/material';
import React, { useEffect, useState, useRef, useMemo, CSSProperties } from 'react';
import { IconReverse } from './icon-handler/icon-reverse';
import { IconRight } from './icon-handler/icon-right';
interface iProps {
  doTitle: string;
  cancelTitle: string;
  value: boolean;
  doFunction: () => boolean | Promise<boolean> | undefined;
  cancelFunction?: Function;
  DoIcon: any;
  index?: number;
  disabled?: boolean;
  style?:CSSProperties
}

export const IconButton = ({
  cancelFunction,
  cancelTitle,
  doFunction,
  DoIcon,
  doTitle,
  value,
  index,
  disabled = false,
  style
}: iProps) => {
  const [loading, setLoading] = useState(false);

  let preVlaue = useRef<any>(value);
  const [intraValue, setIntraValue] = useState(value);
  const handleClick = async () => {
    if(disabled)return
    setLoading(true);
    if (intraValue) {
      let res = null;
      if (cancelFunction) res = await cancelFunction();
      else {
        res = await doFunction();
      }

      if (res) setLoading(false);
    } else {
      let res = await doFunction();
      if (res) setLoading(false);
    }
  };
  useEffect(() => {
    const controller = new AbortController();
  let signal = controller.signal;
    if (preVlaue.current !== value) {
     
      preVlaue.current = value;
      setIntraValue(value);
    }
    return ()=>{
      controller.abort()
    }
  }, [value]);
//   useEffect(()=>{
//     const controller = new AbortController();
//     let signal = controller.signal;
// if(disabled){
// setIntraValue(false)
// }
// return ()=>{
//   controller.abort()
// }
//   },[disabled])

  return (
    <Tooltip title={intraValue ? cancelTitle : doTitle}>
      {intraValue ? (
        <div 
        onClick={() => handleClick()} style={{direction:'rtl', cursor: disabled?'not-allowed':'pointer' ,...style}} >
     
          {loading ? (
            <CircularProgress size={10} />
          ) : (
            <IconReverse
              icon={React.cloneElement(DoIcon, {
                style: { color: disabled?'gray':'var(--primary-color)',fontSize:'1.2rem' },
              })}
            />
          )}
        </div>
      ) : (
        <div onClick={() => handleClick()} style={{ direction:'rtl',cursor: disabled?'not-allowed':'pointer' ,...style}}>
          {loading ? (
            <CircularProgress size={10} />
          ) : (
            React.cloneElement(DoIcon, {
              style: { color:  disabled?'gray':'var(--primary-color)',fontSize:'1.2rem' },
            })
          )}
        </div>
      )}
    </Tooltip>
  );
};
